export enum LocalizableContent {
  SingleLineTextField = "SINGLE_LINE_TEXT_FIELD",
  MultiLineTextField = "MULTI_LINE_TEXT_FIELD",
  Html = "HTML",
  String = "STRING",
  ListSingleLineTextField = "LIST_SINGLE_LINE_TEXT_FIELD",
  ListMultiLineTextField = "LIST_MULTI_LINE_TEXT_FIELD",
  Url = "URL",
  FileReference = "FILE_REFERENCE",
  Uri = "URI",
  Json = "JSON",
  JsonString = "JSON_STRING",
  RichTextField = "RICH_TEXT_FIELD",
  InlineRichText = "INLINE_RICH_TEXT",
  ListFileReference = "LIST_FILE_REFERENCE",
  ListUrl = "LIST_URL",
}